import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Alert,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import instance from '../../utils/axiosConfig';
import { auth } from '../../utils/auth';
import { ThemeProvider } from '@mui/material/styles';
import menuTheme from '../../menuTheme';

function AdminList() {
  const [admins, setAdmins] = useState([]);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [currentAdmin, setCurrentAdmin] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    admin: null
  });

  const currentUser = auth.getUser();

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
        
        setIsSuperAdmin(currentUser.isSuperAdmin);
      const response = await instance.get('/api/admin-management/admins');
      setAdmins(response.data);
    } catch (error) {
      setMessage({
        type: 'error',
        text: 'Error al cargar administradores'
      });
    }
  };

  const handleDeleteClick = (admin) => {
    setDeleteDialog({
      open: true,
      admin: admin
    });
  };

  const handleDeleteCancel = () => {
    setDeleteDialog({
      open: false,
      admin: null
    });
  };

  const handleDeleteConfirm = async () => {
    try {
      await instance.delete(`/api/admin-management/admins/${deleteDialog.admin._id}`);
      setMessage({ type: 'success', text: 'Administrador eliminado exitosamente' });
      fetchAdmins();
      handleDeleteCancel();
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.error || 'Error al eliminar administrador'
      });
    }
  };

  return (
    <Box>
      {message.text && (
        <Alert severity={message.type} sx={{ mb: 2 }}>
          {message.text}
        </Alert>
      )}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Super Admin</TableCell>
              <TableCell>Fecha de Creación</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {admins.map((admin) => (
              <TableRow key={admin._id}>
                <TableCell>{admin.name}</TableCell>
                <TableCell>{admin.email}</TableCell>
                <TableCell>{admin.isSuperAdmin ? 'Sí' : 'No'}</TableCell>
                <TableCell>
                  {new Date(admin.createdAt).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  {currentUser.isSuperAdmin && admin._id !== currentUser.id && (
                    <IconButton
                      onClick={() => handleDeleteClick(admin)}
                      color="error"
                      title="Eliminar administrador"
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {admins.length === 0 && (
        <Typography sx={{ mt: 2, textAlign: 'center' }}>
          No hay administradores para mostrar
        </Typography>
      )}

      {/* Confirmation Dialog */}
      <Dialog
        open={deleteDialog.open}
        onClose={handleDeleteCancel}
      >
        <DialogTitle>Confirmar Eliminación</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro que deseas eliminar al administrador{' '}
            <strong>{deleteDialog.admin?.name}</strong>?
            <br />
            Esta acción no se puede deshacer.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default AdminList; 